module.exports = __webpack_public_path__ + "update-membership-details.svg?2e5a4d4e410becd5236235d9a7b71692";